import React, { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Radio } from "@mui/material";
import {setSelectedPartyId} from "store/slice/PharmaSlice";
import SearchIcon from '@mui/icons-material/Search';
import { setPartyAddPartyModal } from "store/slice/PharmaSlice";
import AddPartyActionModal from "../action/AddParty/AddPartyActionModal";

export default function SelectParty({ sectionHeight}) {
  const dispatch = useDispatch();
  const { partyList, partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const [partyId, setPartyId] = useState(partyObj.id);
  const [filter, setFilter] = useState("");
  

  useEffect(() => {
    if (partyObj && partyObj.id)
      setPartyId(partyObj.id);
    else setPartyId(-1);
    
  },[partyObj]);

  const handleChipClick = (id) => {
    if (partyId === id) {
      setPartyId(null);
      dispatch(setSelectedPartyId(-1));
    } else {
      setPartyId(id);
      dispatch(setSelectedPartyId(id));
    }
  };

  // Filter party list by name
  const filteredPartyList = partyList
    ? partyList.filter((party) =>
        party.title.toLowerCase().includes(filter.toLowerCase())
      )
    : [];

    const addNewParty = () => {
      dispatch(setPartyAddPartyModal(true));
    };

  return (
    <Grid container direction="column" sx={{ width: '100%', backgroundColor: 'secondary.lighter' }}>
      <Grid lg={12} xs={12} item sx={{ mb: 2, display: "flex", alignItems: "center", gap: 2, backgroundColor: 'white', padding: 1, borderRadius: 1 }}>
        <TextField
          label="Filter Party"
          variant="outlined"
          size="small"
          value={filter}
          onChange={e => setFilter(e.target.value)}
          sx={{ flex: 1 }}
          InputProps={{
            startAdornment: (
              <SearchIcon sx={{ color: 'action.active', mr: 1 }} />
            ),
          }}
        />
        <Button variant="contained" onClick={() => addNewParty()}>Add New Party</Button>
      </Grid>
      <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Box sx={{ backgroundColor: 'white', flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
          <Grid item lg={12} xs={12} sx={{ overflowY: "scroll", backgroundColor: 'white', minHeight: sectionHeight, maxHeight: sectionHeight, paddingTop: 2 }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
              {filteredPartyList && filteredPartyList.length > 0 ? (
                filteredPartyList.map((party) => {
                  //const isApproved = party.statusname?.toLowerCase() === "approved";
                  const isApproved = true;
                  return (
                    <Grid
                      lg={3}
                      md={3}
                      sm={3}
                      xs={12}
                      item
                      key={party.id}
                      sx={{
                        width: '100%',
                        margin: 1,
                        backgroundColor: 'primary.lighter',
                        borderRadius: 1,
                        border: partyId === party.id ? '1px solid black' : 'text.primary',
                        padding: 1,
                        cursor: isApproved ? "pointer" : "not-allowed",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        opacity: isApproved ? 1 : 0.5,
                        transition: 'border-color 0.2s',
                        '&:hover': {
                          borderColor: isApproved ? 'primary.light' : 'transparent',
                        },
                        '&:hover .party-title': {
                          color: isApproved ? 'primary.light' : undefined,
                        }
                      }}
                      onClick={() => isApproved && handleChipClick(party.id)}
                    >
                      <Radio
                        checked={partyId === party.id}
                        disabled={!isApproved}
                        value={party.id}
                        color="primary"
                        sx={{ mr: 1 }}
                        onClick={e => {
                          e.stopPropagation();
                          if (isApproved) handleChipClick(party.id);
                        }}
                      />
                      <Typography variant="h6" className="party-title">{party.title}</Typography>
                    </Grid>
                  );
                })
              ) : (
                <Typography variant="body2" color="text.secondary">No parties found</Typography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <AddPartyActionModal />
    </Grid>
  );
}